export const fastMessageStart = ($body, messages) => {
    if(messages.length){
        setTimeout(function () {
            messages.slideUp(function () {
                messages.remove();
            });
        }, 5000);
    }
    $body.on('click','.fm-close',function (e) {
        e.preventDefault();
        $(this).closest('.col-12').slideUp(function () {
            $(this).remove();
        });
    });
}

export const FastMessage = {
    success: 'success',
    error: 'danger',
    warning: 'warning',
    info: 'info',
    createMessage: function(text, $class) {
        const timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
        const $messages = $('.js_fastMessages_row');
        const number = Math.round(Math.random() * 15);
        const temp = $('.js_fastmessage_template');
        const clone = $(temp).clone();
        const item = $(clone.html());
        item.attr("id", number).hide();
        item.find(".js_alert_box").addClass( "alert-" + $class);
        item.find(".js_alert_text").append( text );
        $messages.append(item);
        item.slideDown();
        setTimeout(function () {
            item.slideUp(function () {
                $(this).remove();
            });
        }, timeout);
    },
    createMessageAdmin: function (text, $class = this.success, timeout = 5000) {
        let $messages = $('.FastMessages');
        if(!$messages.length){
            $messages = $('.FastMessagesContainer');
            $messages.append('<div class="FastMessages row">');
            $messages = $('.FastMessages');
        }
        const number = Math.round(Math.random() * 15);
        const html = $(`<div class="col-12"><div class="alert alert-${$class}" id="${number}" role="alert">${text}</div></div>`);
        html.hide();
        $messages.append(html);
        html.slideDown();
        setTimeout(function () {
            $(`#${number}`).slideUp(function () {
                $(this).remove();
            });
        }, timeout);
    }
};